import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import uuid from 'uuid'
import { connect } from 'react-redux'
import { goBack, push } from 'connected-react-router'
import { compose } from 'recompose'

import {
  ajEvents as ajEventsApi,
  blobs as blobsApi,
  participants as participantsApi,
  tasks as tasksApi
} from 'redux/modules/api'
import { logError, modal, notification, setGlobalLoading, setPage } from 'redux/modules/app'
import { schema, schemaSetParticipants, updateSchema } from 'models/aj-events'
import { uploadFilesSchema } from 'models/awards'
import { personId } from 'utils/token'
import { mapParticipantsForSelect } from 'redux/selectors/participants'
import { ACTIVITY_SECTIONS } from 'constants/enums'
import AjEventsFilter from 'constants/filter-enums/aj-events'
import appConfig from 'config'
import { routerAdapter } from 'helpers/decorators'
import { parseAuthCode } from 'utils/authCode'
import { combineAnd } from '../../../../utils/apiFilter'

function emptyAwardsException() {
  this.body = {}
  this.body.userMessage =
    "Nothing to set. Please check if you're assigning correct participant to this AJ event"
  this.body.errorCode = 400
}

function decorator(config = {}) {
  return ComposedComponent => {
    const enhance = compose(
      routerAdapter(),
      connect(
        ({ api, auth, app }) => ({
          ajEvents: api.ajEvents,
          localParticipantEvents: api.tasks.aj.participantEvents,
          localEvents: api.tasks.aj.events,
          user: auth.user,
          activeOrganization: auth.organization,
          commonLimit: app.commonLimit
        }),
        {
          ...ajEventsApi,
          getTasksAjParticipantEvents: tasksApi.aj.getTasksAjParticipantEvents,
          getTasksAjEvents: tasksApi.aj.getTasksAjEvents,
          getTasksOverview: tasksApi.overview.getTasksOverview,
          getParticipant: participantsApi.getParticipant,
          uploadBlob: blobsApi.uploadBlob,
          notification,
          modal,
          push,
          goBack,
          setPage,
          setGlobalLoading,
          logError
        }
      )
    )

    class AjEvents extends Component {
      static propTypes = {
        user: PropTypes.object,
        activeOrganization: PropTypes.object,
        localParticipantEvents: PropTypes.object,
        localEvents: PropTypes.object,
        ajEvents: PropTypes.object.isRequired,
        getAjEvents: PropTypes.func.isRequired,
        getAjEvent: PropTypes.func.isRequired,
        getAjEventFiles: PropTypes.func.isRequired,
        onLoad: PropTypes.func,
        getPublicAjEvent: PropTypes.func.isRequired,
        updateAjEvent: PropTypes.func.isRequired,
        createAjEvent: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        modal: PropTypes.func.isRequired,
        setGlobalLoading: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired,
        setPage: PropTypes.func.isRequired,
        removeAjEventsCache: PropTypes.func.isRequired,
        getTasksAjParticipantEvents: PropTypes.func.isRequired,
        searchAjEventParticipant: PropTypes.func.isRequired,
        getTasksOverview: PropTypes.func.isRequired,
        getParticipant: PropTypes.func.isRequired,
        uploadBlob: PropTypes.func.isRequired,
        uploadAjEventFile: PropTypes.func.isRequired,
        editAjEventFile: PropTypes.func.isRequired,
        deleteAjEventFile: PropTypes.func.isRequired,
        deleteAjEvent: PropTypes.func.isRequired,
        getTasksAjEvents: PropTypes.func.isRequired,
        exportAjEvents: PropTypes.func.isRequired,
        resendAjEventAssessmentRequest: PropTypes.func.isRequired,
        approveAjEventParticipant: PropTypes.func.isRequired,
        approveAjEvent: PropTypes.func.isRequired,
        setAjEventParticipants: PropTypes.func.isRequired,
        assessorApproveAjParticipantEvent: PropTypes.func,
        getAjParticipantEventAssessment: PropTypes.func.isRequired,
        getPublicAjEventAssessmentRequests: PropTypes.func.isRequired,
        changeAjParticipantEventState: PropTypes.func.isRequired,
        changeAjParticipantEventGoal: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        decoFilter: PropTypes.string,
        awardId: PropTypes.number,
        commonLimit: PropTypes.number,
        setAjEventsParams: PropTypes.func,
        setMyAjEventsParams: PropTypes.func
        // reinitAjEvents: PropTypes.func,
      }

      constructor(props) {
        super(props)
        this.key = uuid.v1()
      }

      componentDidMount() {
        let { ajEvents } = this.props
        const { params, commonLimit, setAjEventsParams, setMyAjEventsParams } = this.props
        const isMyList = config.filter === AjEventsFilter.myEvents

        if (config.list && config.useCommonLimit && commonLimit) {
          ajEvents = {
            ...ajEvents,
            limit: commonLimit
          }
          ajEvents.myEvents = {
            ...ajEvents.myEvents,
            limit: commonLimit
          }
          setMyAjEventsParams({ limit: commonLimit })
          setAjEventsParams({ limit: commonLimit })
        }

        config.list &&
          this.handleAjEvents(
            isMyList ? ajEvents.myEvents : ajEvents,
            this.handleGetBaseFilter(config.filter)
          )
        config.myEvents &&
          this.handleAjEvents(
            ajEvents.myEvents,
            this.handleGetBaseFilter(config.filter)
          )
        config.publicDetail &&
          this.handleGetPublicAjEvent(params && params.ajId)
        config.detail && params && this.handleAjEvent(params.id)
        config.files && params && this.handleAjEventFiles(params.id)
      }

      componentWillReceiveProps(nextProps) {
        const { ajEvents, awardId } = this.props
        const { filter, limit, offset, sort } = nextProps.ajEvents
        const {
          filter: myEventsFilter,
          limit: myEventsLimit,
          offset: myEventsOffset,
          sort: myEventsSort
        } = nextProps.ajEvents.myEvents

        if (
          ajEvents.filter !== filter ||
          ajEvents.limit !== limit ||
          ajEvents.offset !== offset ||
          ajEvents.sort !== sort ||
          awardId !== nextProps.awardId
        ) {
          config.list &&
            this.handleAjEvents(
              nextProps.ajEvents,
              this.handleGetBaseFilter(config.filter, nextProps.awardId)
            )
        }

        if (
          ajEvents.myEvents.sort !== myEventsSort ||
          ajEvents.myEvents.filter !== myEventsFilter ||
          ajEvents.myEvents.limit !== myEventsLimit ||
          ajEvents.myEvents.offset !== myEventsOffset
        ) {
          config.list &&
            this.handleAjEvents(
              nextProps.ajEvents.myEvents,
              this.handleGetBaseFilter(config.filter, nextProps.awardId)
            )
        }
      }

      handleGetBaseFilter = (baseFilter, nextAwardId) => {
        const { params, decoFilter, awardId } = this.props

        const currentAwardId = nextAwardId || awardId

        let filter = ''

        switch (decoFilter || baseFilter) {
          case AjEventsFilter.myEvents:
            filter = `createdBy=${personId(this.props.user)}`
            break
          case AjEventsFilter.participantEvents:
            filter = `ajParticipantEvents.award.participant.id=${params && params.id}`
            break
          case AjEventsFilter.awardUnitEvents:
            filter = `organization.id=${params && params.id}`
            break
          case AjEventsFilter.awardEvents:
            filter = `ajParticipantEvents.award.id=${currentAwardId}`
            break
          default:
            filter = ''
        }

        if (config.hideIncompleteData) {
          filter = `or(ajParticipantEvents eq null,ajParticipantEvents.state.value ne SETUP),${filter}`
        }

        return filter
      }

      handleAjEvents = (ajEvents, baseFilter) =>
        this.props
          .getAjEvents(ajEvents, baseFilter, {
            listReadParams: config.listReadParams,
            isMyList: config.filter === AjEventsFilter.myEvents,
            resetFilter: config.resetFilter
          })
          .then(this.handleOnLoad)
          .catch(this.handleError)

      handleAjEvent = id =>
        this.props.getAjEvent(id).then(({ body }) => {
          const ajGlobalId = get(body, 'id')
            ? `(${body.globalId || `ID: ${body.id}`})`
            : ''

          this.props.setPage(
            ` ${get(body, 'ajEventCategory.translationText')} ${ajGlobalId}`,
            true
          )
        })

      handleAjEventFiles = id => this.props.getAjEventFiles(id)

      handleExportAjEvents = () => {
        const { ajEvents } = this.props

        return this.props
          .exportAjEvents(ajEvents, this.handleGetBaseFilter())
          .catch(this.handleError)
      }

      handleGetPublicAjEvent = id => {
        const authCode = parseAuthCode(this.props)

        this.props.getPublicAjEvent(id, authCode).catch(this.handleError)
      }

      handleUpdateAjEvent = fields =>
        this.props
          .updateAjEvent(fields.id, updateSchema(fields))
          .then(() => this.handleEnd('Saved', 'notifications.saved'))
          .catch(this.handleError)

      handleCreateAjEvent = fields => {
        const params = {
          organizationId: this.props.activeOrganization.id
        }

        this.props
          .createAjEvent(schema(fields, params))
          .then(this.handleCreateSuccess)
          .catch(this.handleError)
      }

      handleApproveAjEventParticipant = id =>
        this.props
          .approveAjEventParticipant(id, { approved: true })
          .then(this.handleApproveParticipantEventSuccess)
          .catch(this.handleError)

      handleReturnAjEventParticipant = (id, fields) =>
        this.props
          .approveAjEventParticipant(id, { approved: false, note: fields.note })
          .then(this.handleReturnParticipantEventSuccess)
          .catch(this.handleError)

      handleApproveAjEvent = (id, fields, isAssessorManagementEnabled) => {
        this.props
            .approveAjEvent(id, { approved: true })
            .then(() => {
              this.handleApproveEventSuccess(isAssessorManagementEnabled)
            })
            .catch(this.handleError)
      }

      handleRejectAjEvent = (id, fields) =>
        this.props
          .approveAjEvent(id, { approved: false, note: fields.note, reason: fields.reason })
          .then(this.handleRejectEventSuccess)
          .catch(this.handleError)

      handleSearchAjEventParticipants = (fields = {}, opts = {}) => {
        const { ajEvents } = this.props

        if (fields.name && !opts.disableNameFilter) {
          return this.handleFetchParticipants(
            fields.name,
            get(ajEvents, 'detail.awardLevel.value'),
            opts
          )
        }

        if (opts.disableNameFilter) {
          return this.handleFetchParticipants(
            null,
            get(ajEvents, 'detail.awardLevel.value'),
            opts
          )
        }

        return new Promise((res, rej) => rej())
      }

      handleFetchParticipants = (name, awardLevelValue, opts) => {
        return this.props
          .searchAjEventParticipant(name, awardLevelValue, opts)
          .then(({ body }) => mapParticipantsForSelect(body, opts))
      }

      handleAssessorApproveAjParticipantEvent = () => {
        const { params } = this.props

        this.props
          .assessorApproveAjParticipantEvent(params && params.ajId, {
            approved: true
          })
          .then(this.handleCreateSuccess)
          .catch(this.handleError)
      }

      handleSetAjEventParticipants = (
        id,
        awardLevelValue,
        data,
        { originalParticipantsCount } = {}
      ) => {
        const awardsIds = schemaSetParticipants(awardLevelValue, data) || {}

        if (originalParticipantsCount === 0 && awardsIds.awards.length === 0) {
          this.handleError(new emptyAwardsException())
          return
        }

        return this.props
          .setAjEventParticipants(id, awardsIds)
          .then(this.handleSetParticipantsSuccess)
          .catch(this.handleError)
      }

      handleGetPublicAjEventAssessmentRequests = (
        ajEventId,
        ajEventActionId
      ) => {
        this.props
          .getPublicAjEventAssessmentRequests(
            ajEventId,
            ajEventActionId,
            parseAuthCode(this.props)
          )
          .then(() => {})
          .catch(this.handleError)
      }

      handleChangeAjParticipantEventState = (id, state) => {
        this.props.setGlobalLoading(true)

        this.props
          .changeAjParticipantEventState(id, state)
          .then(() =>
            this.handleEnd(
              'Adventurous journey state has been changed',
              'notifications.adventurous_journey_state_has_been_changed'
            )
          )
          .catch(this.handleError)
      }

      handleChangeAjParticipantEventGoal = (id, fields) => {
        this.props
          .changeAjParticipantEventGoal(id, fields)
          .then(() => this.handleEnd('Saved', 'notifications.saved'))
          .catch(this.handleError)
      }

      handleResendAjEventAssessmentRequest = id => {
        this.props
          .resendAjEventAssessmentRequest(id)
          .then(this.handleSuccessResendAssessment)
          .catch(this.handleError)
      }

      handleDeleteAjEvent = id => {
        this.props
          .deleteAjEvent(id)
          .then(() =>
            this.handleEnd(
              'Adventurous journey has been removed',
              'notifications.adventurous_journey_has_been_removed',
              { redirectToAjList: true }
            )
          )
          .catch(this.handleError)
      }

      handleUploadAjEventFile = fields => {
        const { params } = this.props
        const ajId = params.id

        if (!fields.file) {
          return
        }
        return this.props
          .uploadBlob({
            file: fields.file
          })
          .then(({ body = {} }) => {
            return this.props
              .uploadAjEventFile(
                ajId,
                uploadFilesSchema(fields, body.url, {
                  type: ACTIVITY_SECTIONS.aj.id
                })
              )
              .then(() => {
                this.handleEnd(
                  'File has been uploaded',
                  'notifications.file_has_been_uploaded'
                )
                config.files && params && this.handleAjEventFiles(params.id)
                this.props.modal(null)
              })
              .catch(this.handleError)
          })
          .catch(this.handleError)
      }

      handleEditAjEventFile = fields => {
        const { params } = this.props
        const ajId = params.id

        return this.props
          .editAjEventFile(ajId, fields.id, fields)
          .then(() => {
            this.handleEnd(
              'File has been updated',
              'notifications.file_has_been_updated'
            )
            config.files && params && this.handleAjEventFiles(params.id)
            this.props.modal(null)
          })
          .catch(this.handleError)
      }

      handleDeleteAjEventFile = fileId => {
        const { params } = this.props
        const ajId = params.id

        return this.props
          .deleteAjEventFile(ajId, fileId)
          .then(() => {
            this.handleEnd(
              'File has been removed',
              'notifications.file_has_been_removed'
            )
            config.files && params && this.handleAjEventFiles(params.id)
            this.props.modal(null)
          })
          .catch(this.handleError)
      }

      handleSuccess = () => {
        this.props.removeAjEventsCache()
        this.props.notification('Saved', {
          status: 'success',
          intlKey: 'notifications.saved'
        })
      }

      handleSuccessResendAssessment = () => {
        this.props.notification('Assessment request has been sent', {
          status: 'success',
          intlKey: 'notifications.assessment_request_has_been_sent'
        })
        this.props.modal(null)
      }

      handleCreateSuccess = ({ body }) => {
        this.handleEnd(
          'AJ event has been created',
          'notifications.aj_event_has_been_created'
        )
        this.props.push(
          `${appConfig.publicPath}/adventurous-journeys/${get(body, 'id')}/event-participants`
        )
      }

      handleApproveParticipantEventSuccess = () => {
        this.handleEnd(
          'Adventurous journey has been approved',
          'notifications.adventurous_journey_has_been_approved'
        )
        this.props.getTasksAjParticipantEvents(
          this.props.localParticipantEvents
        )
        this.props.getTasksOverview(null, {
          activeOrganizationId: this.props.activeOrganization.id,
          awardLeaderId: this.props.user.personId
        })
      }

      handleReturnParticipantEventSuccess = () => {
        this.handleEnd(
          'Adventurous journey has been returned',
          'notifications.adventurous_journey_has_been_returned'
        )
        this.props.getTasksAjParticipantEvents(
          this.props.localParticipantEvents
        )
        this.props.getTasksOverview(null, {
          activeOrganizationId: this.props.activeOrganization.id,
          awardLeaderId: this.props.user.personId
        })
      }

      handleApproveEventSuccess = isAssessorManagementEnabled => {
        let text = 'Event has been approved'

        let intlKey = 'notifications.event_has_been_approved'

        if (isAssessorManagementEnabled) {
          text = 'Activity and Assessor have been authorised, Assessor has been sent invitation'
          intlKey = 'notifications.assessor_and_activity_has_been_approved'
        }


        this.handleEnd(text, intlKey)
        const filter = get(this.props, 'decoFilterMyOnly')
          ? `ajEvent.award.awardLeader.person.id=${this.props.user.personId}`
          : ''

        this.props.getTasksAjEvents(this.props.localEvents, filter)
        this.props.getTasksOverview(null, {
          activeOrganizationId: this.props.activeOrganization.id,
          awardLeaderId: this.props.user.personId
        })
      }

      handleRejectEventSuccess = () => {
        this.handleEnd(
          'Event has been rejected',
          'notifications.event_has_been_rejected'
        )
        this.props.getTasksAjEvents(this.props.localEvents)
        this.props.getTasksOverview(null, {
          activeOrganizationId: this.props.activeOrganization.id,
          awardLeaderId: this.props.user.personId
        })
      }

      handleSetParticipantsSuccess = () => {
        const { params } = this.props

        this.handleEnd(
          'Changes have been saved',
          'notifications.changes_have_been_saved'
        )
        params && this.handleAjEvent(params.id)
      }

      handleGetAjParticipantEventAssessment = (ajPeId, ajPeActionId) => {
        this.props
          .getAjParticipantEventAssessment(ajPeId, ajPeActionId)
          .then(() => {})
          .catch(this.handleError)
      }

      handleError = err => {
        console.log('err', err)

        this.props.logError(err, {
          authCode: parseAuthCode(this.props)
        })
        this.props.setGlobalLoading(false)

        // if (
        //   body &&
        //   body.errorCode === 401 &&
        //   get(this.props, 'location.query.authorizationCode')
        // ) {
        //   this.props.notification('Authorization code is no longer valid', {
        //     intlKey: 'notifications.auth_code_is_no_longer_valid',
        //     status: 'error'
        //   })
        //   this.props.push('/')
        //   return
        // }
        // this.props.notification(body && body.userMessage, 'error')
        // this.props.setGlobalLoading(false)
      }

      handleEnd = (text, intlKey, { redirectToAjList } = {}) => {
        const { params, ajEvents } = this.props

        this.props.removeAjEventsCache()
        this.props.modal()
        this.props.notification(text, {
          status: 'success',
          intlKey
        })
        config.updateParticipant &&
          params &&
          this.props.getParticipant(params.id)
        config.updateAjEventDetail && params && this.handleAjEvent(params.id)
        config.updateList &&
          this.handleAjEvents(ajEvents, this.handleGetBaseFilter(config.filter))
        this.handleOnLoad()
        if (redirectToAjList) {
          this.props.push(`${appConfig.publicPath}/adventurous-journeys`)
        }
        this.props.setGlobalLoading(false)
      }

      handleOnLoad = () => {
        if (this.props.onLoad) {
          this.props.onLoad()
        }
      }

      render() {
        return (
          <ComposedComponent
            key={this.key}
            {...this.props}
            updateAjEvent={this.handleUpdateAjEvent}
            createAjEvent={this.handleCreateAjEvent}
            approveAjEventParticipant={this.handleApproveAjEventParticipant}
            returnAjEventParticipant={this.handleReturnAjEventParticipant}
            searchAjEventParticipants={this.handleSearchAjEventParticipants}
            exportAjEvents={this.handleExportAjEvents}
            assessorApproveAjParticipantEvent={
              this.handleAssessorApproveAjParticipantEvent
            }
            setAjEventParticipants={this.handleSetAjEventParticipants}
            approveAjEvent={this.handleApproveAjEvent}
            rejectAjEvent={this.handleRejectAjEvent}
            getAjParticipantEventAssessment={
              this.handleGetAjParticipantEventAssessment
            }
            getPublicAjEventAssessmentRequests={
              this.handleGetPublicAjEventAssessmentRequests
            }
            changeAjParticipantEventState={
              this.handleChangeAjParticipantEventState
            }
            changeAjParticipantEventGoal={
              this.handleChangeAjParticipantEventGoal
            }
            resendAjEventAssessmentRequest={
              this.handleResendAjEventAssessmentRequest
            }
            deleteAjEvent={this.handleDeleteAjEvent}
            uploadAjEventFile={this.handleUploadAjEventFile}
            editAjEventFile={this.handleEditAjEventFile}
            deleteAjEventFile={this.handleDeleteAjEventFile}
            localParticipantEvents={undefined}
            localEvents={undefined}
          />
        )
      }
    }
    return enhance(AjEvents)
  }
}

export default decorator
